import { render, staticRenderFns } from "./alert-modal.vue?vue&type=template&id=1bb304de&scoped=true&"
import script from "./alert-modal.vue?vue&type=script&lang=ts&"
export * from "./alert-modal.vue?vue&type=script&lang=ts&"
import style0 from "./alert-modal.vue?vue&type=style&index=0&id=1bb304de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb304de",
  null
  
)

export default component.exports